import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex justify-between flex-col items-center px-7 py-3 h-[70vh] -translate-y-9" }
const _hoisted_2 = { class: "font-regular text-jm_white leading-none text-center mb-4" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "flex flex-col items-center justify-center" }
const _hoisted_5 = { class: "font-bold leading-4 text-[2.1rem] text-jm_white text-center" }
const _hoisted_6 = { class: "text-jm_white px-4 py-[1rem] text-center leading-[1.60rem] text-[1.1rem]" }

import CloseButton from "@/components/CloseButton.vue";
import DefaultLayout from "../layouts/DefaultLayout.vue";
import logo from "@/assets/images/misc/logo_jaegermeister_white.svg";

export default /*@__PURE__*/_defineComponent({
  __name: 'ageCheckFailed',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DefaultLayout, { "background-image": "people" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _unref(logo),
            alt: "logo",
            class: "w-[100px]"
          }, null, 8, _hoisted_3)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("age_check_failed.failed_header")), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("age_check_failed.failed_content")), 1),
          _createVNode(CloseButton)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})